__turbopack_context__.v({
  "bg": "HeroSection-module__DdXgiW__bg",
  "content": "HeroSection-module__DdXgiW__content",
  "flow": "HeroSection-module__DdXgiW__flow",
  "frame": "HeroSection-module__DdXgiW__frame",
  "heroEntry": "HeroSection-module__DdXgiW__heroEntry",
  "lede": "HeroSection-module__DdXgiW__lede",
  "searchSlot": "HeroSection-module__DdXgiW__searchSlot",
  "title": "HeroSection-module__DdXgiW__title",
  "wrap": "HeroSection-module__DdXgiW__wrap",
});
